import React, { useCallback, useMemo, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { GET_STAFF_MANAGEMENT_EVENTS } from "graphql/query/staff-management-gql";
import StaffManagement from "components/staff-management";
import { PageWrapDefault, Tables } from "components/layout";
import { Localize } from "components/service";
import { useActiveMenuItem, useBreadCrumbs } from "components/use-hooks";


const basePath = StaffManagement.Const.basePath;
const tableHelper = StaffManagement.Helpers.TableMain;
const PAGE_SIZE = 25;

const StaffManagementPage = () => {
    useActiveMenuItem([ "staff-management" ], [ "staff-management" ]);

    const history = useHistory();
    const match = useRouteMatch(`${ basePath }/page/:pageNum`);
    const requestedPage = match ? Number(match.params.pageNum) || 1 : 1;
    const [ searchText, setSearchText ] = useState("");
    const [ lifecycleStatus, setLifecycleStatus ] = useState();
    const [ constructionPeriod, setConstructionPeriod ] = useState([]);
    const [ exhibitionPeriod, setExhibitionPeriod ] = useState([]);
    const [ dismantlingPeriod, setDismantlingPeriod ] = useState([]);

    useBreadCrumbs([ {
        label: Localize({ children: "BREADCRUMBS.Label_StaffManagement" }).props.children,
        path: basePath,
    } ]);

    const resetPage = useCallback(() => {
        if (requestedPage !== 1)
        {
            history.push(basePath);
        }
    }, [ history, requestedPage ]);

    const computedStatus = StaffManagement.Helpers.EventsApi.getComputedStatusVariable(
        lifecycleStatus
    );
    const eventWhere = useMemo(() => StaffManagement.Helpers.EventsApi.buildEventsWhere({
        constructionPeriod,
        exhibitionPeriod,
        dismantlingPeriod,
    }), [ constructionPeriod, exhibitionPeriod, dismantlingPeriod ]);

    return (
        <PageWrapDefault
            dataExist={ true }
            title={ <Localize>PAGES.Title_StaffManagement</Localize> }>
            <Tables.Main
                model="exhibitionEvents"
                query={ GET_STAFF_MANAGEMENT_EVENTS }
                routeUrl={ basePath }
                currentPage={ requestedPage }
                searchText={ searchText }
                objFilter={ eventWhere }
                varSet={ {
                    perPage: PAGE_SIZE,
                    computedStatus,
                } }
                tableHelper={ tableHelper }
                extraClass="staff-management-list__table"
                scroll={ { x: 1532 } }>
                <StaffManagement.Filters.Table
                    searchText={ searchText }
                    setSearchText={ setSearchText }
                    lifecycleStatus={ lifecycleStatus }
                    setLifecycleStatus={ setLifecycleStatus }
                    constructionPeriod={ constructionPeriod }
                    setConstructionPeriod={ setConstructionPeriod }
                    exhibitionPeriod={ exhibitionPeriod }
                    setExhibitionPeriod={ setExhibitionPeriod }
                    dismantlingPeriod={ dismantlingPeriod }
                    setDismantlingPeriod={ setDismantlingPeriod }
                    resetPage={ resetPage } />
            </Tables.Main>
        </PageWrapDefault>
    );
};

export default StaffManagementPage;
